import { dbuiV1ListUsersOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export type UseGetUsersType = {
  prefix?: string;
  page?: number;
  pageSize?: number;
  minCharacters?: number;
};

export const useGetUsers = ({
  prefix,
  page = 0,
  pageSize = 100,
  minCharacters = 0,
}: UseGetUsersType = {}) => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...dbuiV1ListUsersOptions({
      ...defaultOptions(),
      path: { workspace },
      query: { prefix, page, pageSize },
    }),
    enabled: !!workspace && (prefix?.length || 0) >= minCharacters,
  });
};
